export default __webpack_public_path__ + "static/media/emobile.b957e45b.png";